import React, { useState } from 'react';
import ExperienceAccordionSection from './experience-accordion-section';

interface ExperienceReviewProps {
  peerData: { id: number };
  refetchPeerData: () => void;
  onDirtyChange?: (isDirty: boolean) => void;
}

const ExperienceReview: React.FC<ExperienceReviewProps> = ({ peerData, refetchPeerData, onDirtyChange }) => {
  const [openSection, setOpenSection] = useState<string>('');

  const toggleSection = (sectionId: string) => {
    setOpenSection(openSection === sectionId ? '' : sectionId);
  };

  const sections = [
    { id: 'unapproved-audio', title: 'Unapproved Audio', experienceType: 'audio' as const, grade: 'ungraded' as const },
    { id: 'unapproved-video', title: 'Unapproved Video', experienceType: 'video' as const, grade: 'ungraded' as const },
    { id: 'approved-audio', title: 'Approved Audio', experienceType: 'audio' as const, grade: 'approved' as const },
    { id: 'approved-video', title: 'Approved Video', experienceType: 'video' as const, grade: 'approved' as const },
    { id: 'rejected-audio', title: 'Rejected Audio', experienceType: 'audio' as const, grade: 'rejected' as const },
    { id: 'rejected-video', title: 'Rejected Video', experienceType: 'video' as const, grade: 'rejected' as const },
  ];

  return (
    <div className="space-y-4">
      {sections.map((section) => (
        <ExperienceAccordionSection
          key={section.id}
          sectionId={section.id}
          title={section.title}
          experienceType={section.experienceType}
          grade={section.grade}
          isOpen={openSection === section.id}
          toggleSection={toggleSection}
          listenerRoleId={peerData.id}
          refetchPeerData={refetchPeerData}
          onDirtyChange={onDirtyChange}
        />
      ))}
    </div>
  );
};

export default ExperienceReview;
